import React, { useEffect } from "react"
import { useSearchResultsContext } from "../../CandidatsRechercheResults"
import { CandidatSuiviListing } from "../../../../suivi/listing/CandidatSuiviListing"
import { useSearchResultsPreviewContext } from "../_CandidatsRechercheResultsPreview"

export const CandidatsRechercheResultsPreviewHelpersSuivis = () => {
     const { itemInPreview } = useSearchResultsContext()
     const { setIsPreviewBodyLoading } = useSearchResultsPreviewContext()
     const { setItemInPreview } = useSearchResultsContext()

     useEffect(() => {
          setIsPreviewBodyLoading(false)
     }, [itemInPreview?.selectedItem])
     return (
          <div className="preview-height p-5">
               <CandidatSuiviListing
                    candidat_id={itemInPreview?.selectedItem.candidat.id!}
                    onLoad={() => {
                         setIsPreviewBodyLoading(false)
                         setItemInPreview(prev => (prev ? { ...prev, isSelectedItemLoading: false } : null))
                    }}
               />
          </div>
     )
}
